document.addEventListener("DOMContentLoaded", () => {
  const ref = document.referrer;

  if(ref && ref.includes("heygoldys.com/")){
    sessionStorage.setItem("opened_popup", "true");
    sessionStorage.setItem("age-popup-closed", "true");
    setTimeout(showNewsletterPopup, 3000);
  }
  
  function showNewsletterPopup() {
    const newsletterPopup = document.querySelector("popup-modal-newsletter");
    if (newsletterPopup) {
      if (typeof newsletterPopup.schedulePopup === "function") {
        newsletterPopup.schedulePopup();
      } else {
        newsletterPopup.classList.add("active");
      }
    }
  }

  if (ref && ref.includes("https://shopgoldys.com/")) {
    sessionStorage.setItem("opened_popup", "true");
    sessionStorage.setItem("age-popup-closed", "true");
    if(!window.location.href.includes("/pages/goldy-s-daily-ritual-bundle")){
    setTimeout(showNewsletterPopup, 3000);
    }
    if(!window.location.href.includes("/pages/goldy-s-love-bundle")){
    setTimeout(showNewsletterPopup, 3000);
    }
    if(!window.location.href.includes("/pages/goldy-s-420-drop")){
    setTimeout(showNewsletterPopup, 3000);
    }
    if(!window.location.href.includes("/pages/summer-stash")){
    setTimeout(showNewsletterPopup, 3000);
    }
  }




  if (window.location.href.includes("/pages/goldy-s-daily-ritual-bundle")) {
  sessionStorage.setItem("opened_popup", "true");
  sessionStorage.setItem("age-popup-closed", "true");
  }
 
  if (window.location.href.includes("/pages/goldy-s-love-bundle")) {
  sessionStorage.setItem("opened_popup", "true");
  sessionStorage.setItem("age-popup-closed", "true");
  }
  if(ref && ref.includes("https://goldyslegacy.com/")){
    sessionStorage.setItem("opened_popup", "true");
    sessionStorage.setItem("age-popup-closed", "true");
    setTimeout(showNewsletterPopup, 3000); 
  }

  if (!sessionStorage.getItem("opened_popup")) {
    document.querySelector(".age-verification-overlay").classList.add("active");
  }

  const agePopup = document.querySelector(".age-verification-overlay");
  const yesButton = document.querySelector(".age-btn.yes");

  yesButton.addEventListener("click", () => {
    sessionStorage.setItem("opened_popup", "true");
    agePopup.classList.remove("active");
    sessionStorage.setItem("age-popup-closed", "true");
  });
});
